import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_LANGUAGE } from '../utils/constants';

export type SupportedLang = 'ar' | 'en' | 'yo' | 'ha' | 'hi' | 'es' | 'bn';

export const SUPPORTED_LANGUAGES: SupportedLang[] = ['ar', 'en', 'yo', 'ha', 'hi', 'es', 'bn'];

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = useCallback((lang: SupportedLang) => {
    void i18n.changeLanguage(lang);
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
    localStorage.setItem('i18nextLng', lang);
  }, [i18n]);

  const currentLanguage = (i18n.language && SUPPORTED_LANGUAGES.includes(i18n.language as SupportedLang)
    ? i18n.language
    : DEFAULT_LANGUAGE) as SupportedLang;
  const isRTL = currentLanguage === 'ar';

  useEffect(() => {
    const lang = (i18n.language && SUPPORTED_LANGUAGES.includes(i18n.language as SupportedLang)
      ? i18n.language
      : DEFAULT_LANGUAGE) as SupportedLang;
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }, [i18n.language]);

  return {
    currentLanguage,
    isRTL,
    changeLanguage,
    t: i18n.t,
  };
};
